import { Injectable } from '@angular/core';
import { HttpClientService } from '../lib/http/http-client.service';
import { Observable } from 'rxjs/Observable';
import { MessageModel } from '../models/ApiResponseModel';
import { CommonService } from '../shared/services/common.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { CommunityLotModel } from '../models/CommunitylotModel';
import { PersonModel } from '../models/PersonModel';
import { DisplayNotificationListModel } from '../models/SignalrModel';


@Injectable()
export class DashboardService {
  constructor(public http: HttpClientService) {
  }

  public getCommunityLotByBuyerId() {
    return this.http.get('/DashBoard/GetCommunityLotByBuyerId');
  }

  public getOfflineNotifications(): Observable<Array<DisplayNotificationListModel>> {
    return this.http.get('/Notification/GetNotifications');
  }

  public deleteNotifications(communityLotId: number, notificationType: number): Observable<Array<DisplayNotificationListModel>> {
    return this.http.get('/Notification/DeleteNotifications?CommunityLotId=' + communityLotId + "&&NotificationType=" + notificationType);
  }

  public getHomePageMessage() {
    return this.http.get('/DashBoard/GetHomePageMessage');
  }

  public getSalesPersonUserByCommunityLotId(communityLotId: number) {
    return this.http.get('/DashBoard/GetSalesPersonUserByCommunityLotId?CommunityLotId=' + communityLotId);
  }

  public getProjectUserByCommunityLotId(communityLotId: number) {
    return this.http.get('/DashBoard/GetProjectUserByCommunityLotId?CommunityLotId=' + communityLotId);
  }

  public getBuyerNewHomeTeamByCommunityLotID(communityLotId: number) {
    return this.http.get('/DashBoard/GetBuyerNewHomeTeamByCommunityLotID?CommunityLotId=' + communityLotId);
  }

  public getCommunityDocumentByCommunityLotId(communityLotId: number) {
    return this.http.get('/DashBoard/GetCommunityDocumentByCommunityLotId?CommunityLotId=' + communityLotId);
  }

  public getCommunityLotPictureByCommunityLotId(communityLotId: number, contractId: number) {
    return this.http.get('/DashBoard/GetCommunityLotPictureByCommunityLotId?CommunityLotId=' + communityLotId + "&&ContractID=" + contractId);
  }

  public SaveProfile(Buyer: any) {
    return this.http.post('/DashBoard/SaveProfile', Buyer);
  }

  public GetAppintmentListByCommunityLotId(CommunityLotId: number) {
    return this.http.get("/DashBoard/GetAppintmentListByCommunityLotId?CommunityLotId=" + CommunityLotId);
  }

   public getMaterialsManualList () {
    return this.http.get('/DashBoard/GetMaterialsManualList');
  }
   public getHomeOwnerSurveyMsg(ContractId: number) {
    return this.http.get('/DashBoard/GetHomeOwnerSurveyMsg?ContractId=' + ContractId);
  }
   public getHomeOwnerMaintenanceDueMsg(CommunityLotId: number) {
    return this.http.get('/DashBoard/GetHomeOwnerMaintenanceDueMsg?CommunityLotId=' + CommunityLotId);
  }
   public NotifyHomeMaintenanceItemsByCommunitylotid(CommunityLotId: number) {
    return this.http.get('/DashBoard/NotifyHomeMaintenanceItemsByCommunitylotid?CommunityLotId=' + CommunityLotId);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts